export default function Urne() {
    return (
        <div>
            <h1>Urne virtuelle</h1>

            <p>Si vous souhaitez participer financièrement, nous avons prévu une urne virtuelle,<br />
                il vous suffit de faire un virement sur le compte : </p>
                <h3>IBAN : BE42 0357 5440 9154</h3>
                {/* BIC : 00000000 <br /> */}
                <p>Avec comme communication "Mariage Nina & Sam" <br />
                et votre nom pour que nous puissions vous remercier le jour J !</p>
        </div>
    );
}

